import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './RenovationsComponent.metadata.json5';

import styles from '../BuildersRisk.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function RenovationsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('RenovationsComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = _.get(submissionVM.value, 'lobData.consTraAndServLine.coverables.buildersRisk.project.doeTheProInCAnyRenFie')

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifYESdesFie: {
            visible: !_.isUndefined(modelVM.wilthebeanystrworFie.value) && modelVM.wilthebeanystrworFie.value
        },
        ifyespleprodetFie: {
            visible: !_.isUndefined(modelVM.doetheProinvanyexcfouFie.value) && modelVM.doetheProinvanyexcfouFie.value
        },
        ifyeswhaperofthebuoccFie: {
            visible: !_.isUndefined(modelVM.wilthebuibeparoccdactFie.value) && modelVM.wilthebuibeparoccdactFie.value
        },
        ifyeswhatypofoccofoccFie: {
            visible: !_.isUndefined(modelVM.wilthebuibeparoccdactFie.value) && modelVM.wilthebuibeparoccdactFie.value
        },
        isthiHerBuiFie: {
            visible: !_.isUndefined(submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.typofInsReqFie)
                && ['AllOthCOC', 'SmaResCOC'].includes(submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.typofInsReqFie)
        },
        wilanystobeaddtothbuiFie: {
            visible: !_.isUndefined(submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.typofInsReqFie)
                && submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.typofInsReqFie === 'AllOthCOC'
        },
        ifYESexpFie: {
            visible: (!_.isUndefined(submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.typofInsReqFie)
                && submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.typofInsReqFie === 'AllOthCOC') && 
                (!_.isUndefined(modelVM.wilanystobeaddtothbuiFie.value) && modelVM.wilanystobeaddtothbuiFie.value)
        }
        
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

RenovationsComponent.propTypes = wizardProps;
export default withRouter(RenovationsComponent);
